
import { Box, Grid, TablePagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReusableCard from "../../components/reusableComponents/ReusableCard";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ApiService from "../../_services/ApiService";
import { CardSkeletonCollab } from "../../components/reusableComponents/SkeletonCard";
import NoResults from "../../components/reusableComponents/NoResults";
import { useHistory } from "react-router-dom";
import bgimage from "../../img/no_image.png"
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const OfferManagement = () => {
    const history = useHistory();
    const location = useLocation();
    const [offerManagement, setOfferManagement] = useState([])
    const [loader, setLoader] = useState(false)
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const isDraft = location.pathname.includes("view-offer-draft");
    const userData = useSelector((state) => state.userData.userData);

    // ------------------ Event List Get API Call 

    const fetchData = async () => {
        setLoader(true)
        ApiService.get('brand_offers', { offset: page, limit: rowsPerPage, is_draft: isDraft, brand_id: userData?.brand }).then((res) => {
            let response = res?.data?.data
            if (res.status == 200 || res.status == 201) {
                setCount(res?.data?.count)
                setOfferManagement(response)
            }
            setLoader(false)
        }).catch(error => {
            console.log(error)
            setLoader(false)
        })
    }

    useEffect(() => {
        if (userData) {
            fetchData();
        }
    }, [isDraft, userData]);

    // -----------------

    function openSubmission(params) {
        history.push('/offer-management/create-offer')
    }

    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => setRowsPerPage(parseInt(event.target.value, 10));

    const handleToggle = () => {
        if (isDraft) {
            history.push("/offer-management"); // Go to published
        } else {
            history.push("/offer-management/view-offer-draft"); // Go to drafts
        }
    };

    return (
        <Box p={4}>
            <Box display={'flex'} alignItems={{ xs: 'none',sm:'center', md: 'center' }} justifyContent={'space-between'} sx={{ flexDirection: { xs: 'column', sm: 'row', md: 'row' }, paddingBottom: { xs: '20px', sm: 0, md: 0 } }} >
                <ReusableHeadingComponents heading={'Exclusive Offers Management'} subHeading={'Create and control time-bound offers to attract more fans and followers.'} />
                <Box sx={{display:'flex'}}>
                    <ReusableButton children={isDraft ? "View All Published Offers" : "View Saved Drafts"} variant="outlined"
                        classNames={'gn-actionbtn-outline gn-actionbtn-color me-3'} onClick={handleToggle} />
                    <ReusableButton children={'Create new offer'} variant="contained"
                        classNames={'gn-actionbtn'} onClick={openSubmission} />
                </Box>
            </Box>
            <Box mb={4}>
                <Grid container spacing={2}>
                    {console.debug(offerManagement)}
                    {loader ? (
                        ['', '', '', ''].map((d, i) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                                <CardSkeletonCollab />
                            </Grid>
                        ))
                    ) : offerManagement.length ? (
                        offerManagement.map((data, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                <ReusableCard
                                    image={data?.OfferImage || data?.Featured_Banner_URL || bgimage}
                                    title={data?.Title || ''}
                                    // description={`${data?.SubTitle || '-'}`}
                                    OfferButtonLabel={data?.OfferButtonLabel}
                                    OfferURL={data?.OfferURL}
                                    // date={formatEventDate(data?.EventFromDate, data?.EventToDate)}
                                    primaryAction={{ label: "Edit", onClick: () => history.push(`/offer-management/edit-offer/${data?.id}`, { eventData: data }) }}
                                    secondaryAction={{ label: "View", onClick: () => history.push('/offer-management/view-offer', { eventData: data }) }}
                                />
                            </Grid>
                        ))
                    ) : (
                        <NoResults eventNoData="No Offer Found" />
                    )}
                </Grid>


            </Box>
            {/* Pagination */}
            <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ '& p': { margin: '0px' } }}
            />
        </Box>
    );
};

export default OfferManagement;
